import { useMediaQuery, useTheme } from '@mui/material'
import { Navigate } from 'react-router-dom'
import { Formik } from 'formik'

import { useCreateLibraryImpact, useLibraryImpact } from 'src/hooks'
import { MainContainer, ImpactLibraryForm, HelperWrapper } from 'src/components'

import { ETranslationNs, IImpactLibraryForm } from 'src/types'
import { libraryImpactSchema } from 'src/common/validations'
import { initialFormState } from './form/state.form'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { generateFormState } from '../edit-library-impact/form/state.form'

const AddLibraryImpactScreen = () => {
  const { mutateAsync: addLibraryImpact, isSuccess, isLoading } = useCreateLibraryImpact()
  const theme = useTheme()
  const { data: libraryImpact, isLoading: isImpactLoading } = useLibraryImpact()

  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const handleFormSubmit = async (values: IImpactLibraryForm) => {
    await addLibraryImpact(values)
  }

  if (isSuccess) {
    return <Navigate to={joinAbsRoute(ROUTES.IMPACTS_LIBRARY)} />
  }

  if (isImpactLoading) return null

  return (
    <MainContainer
      headerTitle={
        isLaptop ? (
          <HelperWrapper t="impacts-header-title-add" />
        ) : (
          <HelperWrapper t="impacts-header-title" ns={ETranslationNs.Navbar} />
        )
      }
      navigateBack
    >
      <Formik
        initialValues={libraryImpact ? generateFormState(libraryImpact) : initialFormState}
        validationSchema={libraryImpactSchema}
        validateOnBlur={false}
        onSubmit={handleFormSubmit}
      >
        <ImpactLibraryForm isLoading={isLoading} isAddingNew />
      </Formik>
    </MainContainer>
  )
}

export default AddLibraryImpactScreen
